<template>
    <modal @close="closeFromModal">
        <h5 slot="header">Renseigner les identifiants Pointex</h5>
        <div slot="body">
            <p class="mb-3">
                Établissement : <strong>{{ restaurant.name }}</strong>
            </p>
            <form id="pointex-identifiers-form" @submit.prevent="save">
                <input-component
                    v-model="form.manhattan_site_id"
                    :disabled="isLoading"
                    :form-errors="errors.form"
                    input-name="manhattan_site_id"
                    input-type="number"
                    label="Identifiant du site Manhattan"
                    min="1"
                    required />
                <input-component
                    v-model="form.pointex_licence_number"
                    :disabled="isLoading"
                    :form-errors="errors.form"
                    input-name="pointex_licence_number"
                    input-type="number"
                    label="Numéro de licence établissement Pointex"
                    min="1"
                    max="2147483647"
                    required />
            </form>
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-secondary btn-sm btn-circle" :disabled="isLoading" @click="close">
                Annuler
            </button>
            <button form="pointex-identifiers-form" class="btn btn-success btn-sm btn-circle ms-2" :disabled="isLoading">Enregistrer</button>
        </div>
    </modal>
</template>

<script>
import InputComponent from "../../../forms/InputComponent.vue";

export default {
    components: {
        InputComponent,
    },
    props: {
        restaurant: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            errors: {
                form: null,
            },
            form: {
                manhattan_site_id: this.restaurant.manhattan_site_id,
                pointex_licence_number: this.restaurant.pointex_licence_number,
            },
        };
    },
    methods: {
        save() {
            this.isLoading = true;
            this.errors.form = null;

            this.httpPut(`/api/admin/restaurants/${this.restaurant.id}/pointex-identifiers`, this.form)
                .then((response) => {
                    if (response !== false) {
                        this.$emit("saved", response.data.data);
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        close() {
            if (!this.isLoading) {
                this.$emit("close");
            }
        },
        closeFromModal(event) {
            if (event && event.target && !event.target.classList.contains("modal-wrapper")) {
                event.stopPropagation();
            } else {
                this.close();
            }
        },
    },
};
</script>
